import React, { Component } from "react";


class FilteredCards extends Component {

  render() {

    var cards = this.props.cards;
    var clickHandler = this.props.clickHandler;

    return (
      cards.map(function(Card, i){
        return (

          <picture key={Card.CardId}><source media="(min-width:100px)" srcSet={"../Images200/"+ Card.CardId +".png"} />
            <img alt="" src={"../Images200/"+ Card.CardId +".png"} className="img-fluid" id={Card.CardId} onClick={clickHandler} /></picture>

          )
      })
    );
  }
}

export default FilteredCards;



// WEBPACK FOOTER //
// ./src/DeckBuilderComponents/FilteredCards.js